import { ScreenType } from '../config/ScreenConfig';

import { FilterSelection } from './SearchBar/FilterResolvers';
import { PeopleFieldType } from './__generated__/StaffDirectoryViewQuery.graphql';

export const DEFAULT_SCREEN_TYPE: ScreenType = 'BROWSE_ALL';

export const PEOPLE_FIELD_SCREEN_TYPES: ScreenType[] = ['BROWSE_DEPARTMENTS', 'BROWSE_JOB_TITLES', 'BROWSE_LOCATIONS'];

export const TEAM_SEARCH_SCREEN_TYPES: ScreenType[] = ['SEARCH_TEAMS', 'YOUR_TEAMS'];
export const SEARCH_BAR_PREVIEW_TQL_SCREEN_TYPES: ScreenType[] = [...PEOPLE_FIELD_SCREEN_TYPES, 'BROWSE_ALL'];

export const getPageTitleFromScreenType = (screenType: ScreenType) => {
  switch (screenType) {
    case 'SEARCH_PEOPLE':
      return 'People';
    case 'SEARCH_TEAMS':
    case 'YOUR_TEAMS':
      return 'Teams';
    case 'BROWSE_KUDOS':
      return 'Kudos';
    default:
      return '';
  }
};

export const getPeopleFieldType = (screen: ScreenType): PeopleFieldType => {
  switch (screen) {
    case 'BROWSE_JOB_TITLES':
      return 'JOB_TITLE' as PeopleFieldType;
    case 'BROWSE_LOCATIONS':
      return 'LOCATION' as PeopleFieldType;
    default:
      return 'DEPARTMENT' as PeopleFieldType;
  }
};

export const SEARCH_ENABLED_SCREEN_TYPES: ScreenType[] = [
  'BROWSE_ALL',
  'SEARCH_ALL',
  'SEARCH_PEOPLE',
  'SEARCH_TEAMS',
  'BROWSE_KUDOS',
  'YOUR_TEAMS',
];

export const TEAM_APP_SEARCH_ENABLED_SCREEN_TYPES: ScreenType[] = [
  'SEARCH_PEOPLE',
  'SEARCH_TEAMS',
  'YOUR_TEAMS',
  // Kudos filtering is handled within the search component. Search is not actually available for kudos.
  'BROWSE_KUDOS',
];

export const TEAM_APP_HEADER_ENABLED_SCREEN_TYPES: ScreenType[] = [
  ...TEAM_APP_SEARCH_ENABLED_SCREEN_TYPES,
  'BROWSE_KUDOS',
];

// Restrict based on the screen, otherwise based on current filters
export const filterRestrictionForScreen = (
  currentFilterSelection: FilterSelection,
  currentScreen: ScreenType,
): FilterSelection => {
  switch (currentScreen) {
    case 'SEARCH_PEOPLE':
      return 'people';
    case 'SEARCH_TEAMS':
    case 'YOUR_TEAMS':
      return 'teams';
    case 'BROWSE_KUDOS':
      return 'kudos';
    default:
      return currentFilterSelection;
  }
};
